import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var AccountPlans = require("lib/account/AccountPlans");
var DropDownOptions = require("components/utility/DropDownOptions");
var LoadingButton = require("components/utility/LoadingButton");
var Spinner = require("components/utility/Spinner");
var UpgradeHeader = require("components/users/teachers/upgrade/UpgradeHeader");
var UpgradeTokenForm = require("components/users/teachers/upgrade/UpgradeTokenForm");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var Glyphicon = require("components/utility/icons/Glyphicon");
var CreditCardInput = require("components/payments/CreditCardInput");

require("users/teachers/account_customizer.scss");

class AccountCustomizer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			currentView: PROFILE, loading: false,
			loadingBilling: false, billingHistory: null, showPaymentMethodForm: false
		};
	}

	handlePersonalInformationSubmit(e) {
		$wr.nope(e)
		var firstName = this.refs.first_name.value;
		var lastName = this.refs.last_name.value;
		var title = this.refs.title.value;
		var username = this.refs.username.value;
		var email = this.refs.email.value;
		var newPassword = this.refs.new_password.value;
		var confirmedPassword = this.refs.confirmed_password.value;
		var currentPassword = this.refs.current_password.value;

		var params = { first_name: firstName, last_name: lastName, 
			title: title, username: username, email: email }

		if (newPassword || confirmedPassword || currentPassword) {
			_.extend(params, {
				password: newPassword, password_confirmation: confirmedPassword, current_password: currentPassword
				// double_password: newPassword, current_password: currentPassword
			});
		}
		var adminId = CurrentUser.get().id;
		this.setState({ loading: true })
		CurrentUser.api().patchAdmin(adminId, { admin: params }, $wr.apiHandler((response) => {
			if (response.admin.errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sorry!", text: response.admin.errors.join(", "), 
					icon: "exclamation-sign", type: "error" });
				this.setState({ loading: false });
			} else {
				setTimeout(() => {
					window.wrNotifications.triggerDropDownNotification({
						title: "Information Edited", text: ("You successfully changed your account information."), 
						icon: "ok-sign" });
				}, 1000)
				CurrentUser.fetchCurrentUserData(() => {
					this.forceUpdate();
					this.setState({ loading: false });
				});
			}
		}));
	}

	deleteSubscription(e) {
		$wr.nope(e)
		if (confirm("Are you sure you want to cancel your subscription?")) {
			var currentUser = CurrentUser.get();

			var params = { admin: { account: { has_credit_card: false } } };
			CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler((response) => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Subscription Canceled", text: "You have canceled your subscription.", icon: "trash" });					
				CurrentUser.fetchCurrentUserData(() => {
					this.forceUpdate();
				});
			}));
		}
	}

	// to do
	sendReceipt(chargeData, e) {
		$wr.nope(e)

		var params = { what: "premium_account_receipt",
			stripe_payment_id: chargeData.stripe_payment_id }

		CurrentUser.api().postUserTrigger(CurrentUser.get().id, params, $wr.apiHandler((response) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Sent!", text: "Check your inbox for your receipt.", icon: "envelope" });					
		}));

	}

	viewName(viewKey) {
		if (viewKey == PROFILE) {
			return "Profile";
		} else if (viewKey == PLAN) {
			return "Plan";
		} else if (viewKey == BILLING) {
			return "Billing";
		}
	}
	toggleView(viewKey, e) {
		$wr.nope(e)
		this.setState({ currentView: viewKey }, () => {
			if (viewKey == BILLING && !this.state.billingHistory) {
				this.fetchBillingHistory();
			}			
		});
	}

	currentPlan() {
		return CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
	}
	hasCreditCard() {
		return CurrentUser.get().account.has_credit_card;
	}
	isPaying() {
		return CurrentUser.get().account.paying;
	}
	planClassCount() {
		return CurrentUser.get().account.plan_student_list_count;
	}
	nextChargeTime() {
		return CurrentUser.get().account.next_charge_time;
	}
	nextChargeAmount() {
		return CurrentUser.get().account.next_charge_cents;
	}

	planName(plan) {
		plan = plan || this.currentPlan();
		return AccountPlans.name(plan);
	}

	onPaymentSubmit(e) {
		$wr.nope(e)
		this.setState({ loadingPaymentUpdate: true });

		var currentUser = CurrentUser.get()
		var userData = { name: (currentUser.first_name + " " + currentUser.last_name),
			email: currentUser.email };

		this.refs.creditCard.tokenize(userData, (success, tokenData) => {
			if (success) {
				var params = {
					admin: {
						account: {
							update_card: true
						}
					},
					card_token_data: tokenData
				};
				CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler((response) => {
					window.wrNotifications.triggerDropDownNotification({
						title: "Upgrade",
						text: "You have added a new payment method!",
						icon: "star"
					});
					CurrentUser.fetchCurrentUserData(() => {
						this.setState({ loadingPaymentUpdate: false, showPaymentMethodForm: false });
					});
				}));

			} else {
				this.setState({ loadingPaymentUpdate: false });
			}
		});

	}

	toggleEditPaymentMethod(e) {
		$wr.nope(e)
		this.setState({ showPaymentMethodForm: !this.state.showPaymentMethodForm });
	}

	editPlanLink() {
		var plan = this.currentPlan();
		if (plan == AccountPlans.SILVER_PLAN_2019 || plan == AccountPlans.SILVER_SEMESTER_PLAN_2019) {
			return "/upgrade?plan=silver";
		} else {
			return "/upgrade?plan=gold";			
		}
	}

	planPricingInfo() {
		return AccountPlans.pricingSummary(this.currentPlan());
	}

	renderLeftNavLink(viewKey) {
		var navClassName = "leftNavLink";
		if (this.state.currentView == viewKey) {
			navClassName += " selected";
		}
		return (
			<a href="#" onClick={ this.toggleView.bind(this, viewKey) }
				className={ navClassName } key={ viewKey }>
				{ this.viewName(viewKey) }
			</a>
		);
	}

	renderProfileView() {
		var user = CurrentUser.get();

		return (
			<form className="personalInfoForm" onSubmit={ this.handlePersonalInformationSubmit }>
				<div className="inputRow">
					<label className="inputContainer">
						First Name
						<input className="form-control" ref="first_name" 
							defaultValue={ user.first_name } />
					</label>
					<label className="inputContainer">
						Last Name
						<input className="form-control" ref="last_name" 
							defaultValue={ user.last_name } />
					</label>
					<label className="inputContainer">
						Title
						<select ref="title" defaultValue={ user.title } 
							className="form-control selectOptions">
							{ DropDownOptions.Select.Titles() }
						</select>
					</label>
				</div>
				<div className="inputRow">
					<label className="inputContainer emailInput">
						Email
						<input className="form-control" ref="email" placeholder="Enter your email"
							defaultValue={ user.email } />
					</label>
					<label className="inputContainer">
						Username
						<input className="form-control" ref="username" 
							defaultValue={ user.username } placeholder="Enter a username (optional)" />
					</label>
				</div>
				<div className="inputRow">
					<label className="inputContainer">
						Current Password
						<input type="password" className="form-control" 
							ref="current_password" />
					</label>
					<label className="inputContainer">
						New Password
						<input type="password" className="form-control" 
							ref="new_password" />
					</label>
					<label className="inputContainer">
						Confirm Password
						<input type="password" className="form-control" 
							ref="confirmed_password" />
					</label>
				</div>
				<LoadingButton className="btn buttonSuccess center-block" loading={ this.state.loading }
					text="Save Information" />
			</form>
		);
	}

	renderPlanView() {
		var currentPlan = this.currentPlan();

		var sectionClassName = "currentPlan";

		var planPaymentStatus = CurrentUser.get().account.plan_payment_status;

		if (currentPlan == AccountPlans.STARTER_PLAN && CurrentUser.get().role != "adminRole" && CurrentUser.get().account.product != "wrGold") {
			sectionClassName += " starterPlan";
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planLabel">
						Current Plan:
					</div>
					{ this.planName() }
				</div>
			);
			var benefitsList = _.map(UpgradeHeader.BENEFITS.silver, (benefitText) => {
				return (
					<div className="benefitItem" key={ benefitText }>
						<Glyphicon icon="ok" />
						<div className="benefitText">{ benefitText }</div>
					</div>
				);
			});
			var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;
			var currentSilverTrial = CurrentUser.get().account.active_trials.wrSilver != undefined;
			
			var expiredGoldTrial = CurrentUser.get().account.expired_trials.wrGold != undefined;
			var currentGoldTrial = CurrentUser.get().account.active_trials.wrGold != undefined;

			if (!expiredSilverTrial && !currentSilverTrial) {
				var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
				var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
				var trialLink = (<a href={ trialURL }>Start 30 day trial</a>)
				var className = "btn buttonDefault";
				
			} else {
				var className = "btn btn-link";
			}

			if (currentGoldTrial) {
				var currentTrialDetails = (
					<div className="planSection">
						<div className="planLabel">
							Current Trial:
						</div>
						Gold
					</div>
				);
			} else if (currentSilverTrial) {
				var currentTrialDetails = (
					<div className="planSection">
						<div className="planLabel">
							Current Trial:
						</div>
						Silver
					</div>
				);
			}


			var additionalInfo = (
				<div className="upgradeBox">
					<div className="upgradeSentence">
						Upgrade to Silver
					</div>
					<div className="benefitsList">
						{ benefitsList }
					</div>
					<div className="upgradeContainer">
						<a href="/upgrade?plan=silver" className="btn buttonSuccess">
							Upgrade
						</a>
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") } className={ className }>
							Learn More
						</a>
						{ trialLink }
					</div>
				</div>
			);
		} else if (this.isPaying()) {
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planRow">
						<div className="planLabel">
							Current Plan:
						</div>
						{ this.planName() }
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") }
							className="changeLink">
							Change
						</a>
					</div>
					<div className="planRow">
						<div className="planLabel">
							Plan Price:
						</div>
						{ this.planPricingInfo() }
					</div>
					<div className="planRow">
						<div className="planLabel">
							Class Count:
						</div>
						{ $wr.pluralizeWithNumber("class", this.planClassCount(), "classes") }
						<Link to={ this.editPlanLink() }
							className="changeLink">
							Add classes
						</Link>
					</div>
				</div>
			);

			if (this.hasCreditCard()) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Next Charge:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Charge Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) }
								<a href="#" onClick={ this.deleteSubscription }
									className="changeLink">
									Cancel
								</a>
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								{ CurrentUser.paymentMethodSummary() }
								<a href="#" onClick={ this.toggleEditPaymentMethod }
									className="changeLink">
									Edit
								</a>
							</div>
						</div>
					</div>
				);

			} else if (planPaymentStatus == CREDIT_CARD_REMOVED) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Cancellation Date:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Charge Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) } (will not be charged)
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								None
								<a href="#" onClick={ this.toggleEditPaymentMethod }
									className="changeLink">
									Add payment method
								</a>
							</div>
						</div>
					</div>
				);

			} else if (planPaymentStatus == PURCHASE_ORDER_ACTIVE) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Renewal Date:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Renewal Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								Purchase Order
							</div>
						</div>
					</div>
				);
			}
		}

		if (CurrentUser.get().role == "adminRole" || CurrentUser.get().account.product == "wrGold") {
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planRow">
						<div className="planLabel">
							Current Plan: 
						</div>
						Gold 
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") }
							className="changeLink">
							Change
						</a>
					</div>
				</div>
			);
		} else {
			var upgradeTokenForm = (<UpgradeTokenForm requireToggle />)
		}

		if (this.state.showPaymentMethodForm) {
			var paymentInfo = { stripe_public_key: CreditCardInput.STRIPE_PUBLIC_KEY };

			var updatePaymentForm = (
				<div className="updatePaymentForm">
					<div className="purchaseDisclaimer">
						By adding your payment information, you authorize Whooo's Reading to charge you
						every year until you cancel your subscription.
					</div>

					<CreditCardInput ref="creditCard" paymentInfo={ paymentInfo } />

					<div className="submitButton">
						<LoadingButton className="btn buttonSuccess" onClick={ this.onPaymentSubmit }
							loading={ this.state.loadingPaymentUpdate } text="Update Account" />
					</div>

				</div>
			)
		}

		return (
			<div className={ sectionClassName }>
				{ currentPlanDetails }
				{ currentTrialDetails }
				{ additionalInfo }
				{ updatePaymentForm }
				{ upgradeTokenForm }
			</div>
		);
	}

	renderHistoryRow(rowContent, key) {
		var contents = _.map(rowContent, (cellContent, index) => {
			return (
				<div className="historyCell" key={ index }>
					{ cellContent }
				</div>
			);
		});
		return (
			<div className="historyRow" key={ key }>
				{ contents }
			</div>
		);
	}
	renderBillingView() {
		if (this.state.billingHistory == null) {
			return (
				<div className="billingHistory">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			)
		}

		if (this.state.billingHistory.length == 0) {
			return (
				<div className="billingHistory">
					You have no billing history.
				</div>
			);
		}

		var chargeHistoryRows = _.map(this.state.billingHistory, (chargeData, index) => {
			var receiptLink = (
				<a href="#" className="receiptLink"
					onClick={ this.sendReceipt.bind(this, chargeData) }>
					Send
				</a>
			);

			var date = $wr.formatDate(chargeData.date);

			if (chargeData.waived) {
				var chargeAmount = "Waived";
			} else {
				var chargeAmount = $wr.centsToDollars(chargeData.cents, true);
			}

			var classText = $wr.pluralizeWithNumber("class", chargeData.student_list_count, "classes");
			var planText = chargeData.plan_name + " (" + classText + ")";

			return this.renderHistoryRow([date, planText, chargeAmount, receiptLink], index);
		});

		return (
			<div className="billingHistory">
				<div className="historyHeader">
					{ this.renderHistoryRow(["Date", "Plan", "Amount", "Receipt"], "header") }
				</div>
				{ chargeHistoryRows }
			</div>
		);
	}

	render() {
		if (!CurrentUser.isLoaded()) {
			return (
				<div className="accountCustomizer">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		var leftNavLinks = _.map(LEFT_NAV_LINKS, (viewKey) => {
			return this.renderLeftNavLink(viewKey);
		});

		if (this.state.currentView == PROFILE) {
			var currentViewContent = this.renderProfileView();
		} else if (this.state.currentView == PLAN) {
			var currentViewContent = this.renderPlanView();
		} else if (this.state.currentView == BILLING) {
			var currentViewContent = this.renderBillingView();
		}

		return (
			<div className="accountCustomizer">
				<div className="leftNavSection">
					{ leftNavLinks }
				</div>
				<div className="currentViewContent">
					{ currentViewContent }
				</div>
			</div>
		);
	}

	fetchBillingHistory() {
		this.setState({ loadingBilling: true });
		CurrentUser.api().getUser(CurrentUser.get().id, { embed: "user.billing_history" }, (response) => {
			this.setState({ loadingBilling: false, billingHistory: response.user.billing_history || [] });
		});
	}
}

var PROFILE = "profile";
var PLAN = "plan";
var BILLING = "billing";

var LEFT_NAV_LINKS = [PROFILE, PLAN, BILLING];

// Plan status types
var CREDIT_CARD_ACTIVE = "credit-card-active";
var CREDIT_CARD_REMOVED = "credit-card-removed";
var CREDIT_CARD_EXPIRED = "credit-card-expired";
var PURCHASE_ORDER_ACTIVE = "credit-card-active";
var PURCHASE_ORDER_EXPIRED = "credit-card-expired";
var STATUS_UNKNOWN = "status-unknown";

module.exports = AccountCustomizer;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/AccountCustomizer.js